<script setup lang="ts">
import { computed } from 'vue'

interface Props {
    title?: string
    message?: string
    retryText?: string
    showRetry?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    title: undefined,
    message: undefined,
    retryText: undefined,
    showRetry: false,
})

defineEmits<{
    close: []
    retry: []
}>()

const { t } = useI18n()
const displayRetryText = computed(() => props.retryText ?? t('courseCategory.courses.retry'))
</script>

<template>
    <div v-if="title || message"
         class="inline-error max-w-md p-6 bg-[#FFF0F3]  rounded-xl shadow-sm relative">
        <!-- <button @click="$emit('close')" class="absolute top-4 right-4 text-[#D00045] hover:opacity-70 transition-opacity">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
      </svg>
    </button> -->

        <div class="flex items-start gap-3">
            <div class="mt-[2px] bg-[#D00045] rounded-full p-0.5 text-white">
                <svg xmlns="http://www.w3.org/2000/svg"
                     width="18"
                     height="18"
                     viewBox="0 0 24 24"
                     fill="none"
                     stroke="currentColor"
                     stroke-width="3"
                     stroke-linecap="round"
                     stroke-linejoin="round">
                    <line x1="12"
                          y1="8"
                          x2="12"
                          y2="12" />
                    <line x1="12"
                          y1="16"
                          x2="12.01"
                          y2="16" />
                </svg>
            </div>

            <div class="flex-1">
                <div v-if="title"
                     class="inline-error-title text-[#1A1A1A] text-lg leading-tight mb-2">
                    {{ title }}
                </div>
                <p v-if="message"
                   class="inline-error-message text-[#4A4A4A] text-[15px] leading-relaxed mb-5">
                    {{ message }}
                </p>

                <UIErrorButton
                    v-if="showRetry"
                    @click="$emit('retry')"
                >
                    {{ displayRetryText }}
                </UIErrorButton>
            </div>
        </div>
    </div>
</template>

<style scoped>
.inline-error {
    font-family: var(--font-inter);
}

.inline-error-title {
    font-family: var(--font-inter);
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-body);
    line-height: 1.4;
    color: var(--color-section-title);
}

.inline-error-message {
    font-family: var(--font-inter);
}
</style>